import Image, { ImageProps } from 'next/image';
import DanaAvatarImg from './images/dana-avatar.png';

export const DietitianAvatarIcon = (props: Omit<ImageProps, 'src'>) => {
  return <Image {...DanaAvatarImg} {...props} width={60} height={60} />;
};
